import {
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalOverlay,
    useDisclosure
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React from 'react'
import ContentAsset from '../components/content-asset'

export const ContentAssetModal = ({cid, ...props}) => {
    return (
        <Modal variant="content" data-testid="content-modal" {...props}>
            <ModalOverlay />
            <ModalContent>
                <ModalCloseButton />
                <ModalBody>
                    <ContentAsset id={cid} />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}
ContentAssetModal.propTypes = {
    cid: PropTypes.string
}

export const useContentAssetModal = (cid) => {
    const {isOpen, onOpen, onClose} = useDisclosure()

    return {
        cid,
        isOpen,
        onOpen,
        onClose
    }
}
